<template>
  <div class=""></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {
    location.href =
      'weixin://dl/business/?appid=wx64a395f86f7a600c&path=pages/image-page/index&query=url%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fuploads%252F4fa4feffdc303e255a35fc7e21afa595_wh%253D1500_3960.png&env_version=release'
  },
  methods: {}
}
</script>
<style lang="scss" scoped></style>
